import React, { useState, useEffect } from "react"
import { StyledDOMSlider, StyledWrapper } from "./styles"

function RangeSlider(props = {}) {
  const {
    defaultMinValue = 1,
    defaultMaxValue = 25,
    defaultStepMoveValue = 1,
    defaultValue = 0,
    onUpdate = () => "",
    defaultSuffixTextMove = "days",
    size = "medium", // small, medium,
    disabled = false,
    minWidth = 350,
    style = {},
  } = props || {}

  const [value, setValue] = useState(1)

  useEffect(() => {
    // console.log('kvk rs defaultValue', defaultValue)
    let val
    if (defaultValue > 0) {
      val = defaultValue
    } else {
      val = defaultMinValue
    }

    setValue(val)
    onUpdate({ value: val, type: "initial" })
  }, [])

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  useEffect(() => {
    if (defaultValue === 0) {
      setValue(defaultMinValue)
      onUpdate({ value: defaultMinValue, type: "initial" })
    }
  }, [defaultMinValue])

  const customRangeProps = {
    disabled: disabled,
    key: defaultMinValue,
    valueLabelDisplay: "auto",
    value: value,
    min: defaultMinValue,
    max: defaultMaxValue,
    step: defaultStepMoveValue,
    marks: [
      { value: defaultMinValue, label: `${defaultMinValue}` },
      { value: defaultMaxValue, label: `${defaultMaxValue}` },
    ],
    onChange: (event, newValue) => {
      setValue(newValue)
      onUpdate({ value: newValue, type: "current" })
    },
    valueLabelFormat: (value) => `${value} ${defaultSuffixTextMove}`,
  }
  return (
    <StyledWrapper size={size} style={{ minWidth, ...style }}>
      {defaultMinValue === defaultMaxValue ? (
        <div style={{ position: "relative" }}>
          <div className="cls-static-suffix">
            {defaultMinValue + " " + defaultSuffixTextMove}
          </div>
          <div className="cls-static-thumb" />
          <div className="cls-static-suffix2">{defaultMinValue}</div>
        </div>
      ) : (
        <StyledDOMSlider {...customRangeProps} />
      )}
    </StyledWrapper>
  )
}

export { RangeSlider }
export default RangeSlider
